import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TeamMembersWithBranchNameDto } from '../../commonTypes/acs';
import { SelectItem } from '../../components/Common/SearchableMultiSelect';
import { restoreAll, RootState } from '..';

export interface AddTeamMembersSlice {
    isEdit: boolean;
    teamMembers: TeamMembersWithBranchNameDto[];
    selectedMembers: TeamMembersWithBranchNameDto[];
    selectItems: SelectItem[];
    initialSelectItems: SelectItem[];
}

const initialState: AddTeamMembersSlice = {
    isEdit: false,
    teamMembers: [],
    selectedMembers: [],
    selectItems: [],
    initialSelectItems: [],
};

type SetSelectItemsAction = PayloadAction<SelectItem[]>;

export const addTeamMembersSlice = createSlice({
    name: 'addTeamMembers',
    initialState,
    extraReducers: builder => builder.addCase(restoreAll, () => initialState),
    reducers: {
        setSelectItems: (state, action: SetSelectItemsAction) => {
            state.selectItems = action.payload;
        },
        resetSelectItemsToInit: state => {
            state.selectItems = state.initialSelectItems.map(member => ({ ...member }));
        },
        changeSelectedMembers: state => {
            const selectedItemsIds = state.selectItems.filter(item => item.selected).map(item => item.id);
            const newSelectedMembers = state.teamMembers.filter(member => selectedItemsIds.includes(member.userSub));
            state.selectedMembers = newSelectedMembers;
        },
    },
});
export const { setSelectItems, resetSelectItemsToInit, changeSelectedMembers } = addTeamMembersSlice.actions;

export const selectSelectItems = (state: RootState) => state.addTeamMembers.selectItems;

export default addTeamMembersSlice.reducer;
